import { render, staticRenderFns } from "./AddNewApp.vue?vue&type=template&id=62f39e98&scoped=true&"
import script from "./AddNewApp.vue?vue&type=script&lang=js&"
export * from "./AddNewApp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewApp.vue?vue&type=style&index=0&id=62f39e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f39e98",
  null
  
)

component.options.__file = "AddNewApp.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VContainer,
  VContent,
  VFlex,
  VForm,
  VLayout,
  VSelect,
  VTextField,
})
